
export async function toHashStringAsync(input: string) {
  const encoder = new TextEncoder()
  const data = encoder.encode(input)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return btoa(String.fromCharCode(...hashArray))
}

export function toBase64Url(plainBase64: string) {
  return plainBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function secureRandom256() {
  const bytes = crypto.getRandomValues(new Uint8Array(32)) // 256 bits
  const binaryStr = String.fromCharCode(...bytes)
  return toBase64Url(btoa(binaryStr))
}